import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#3D2A3A] py-16 px-4 border-t border-white/10" data-id="element-90">
      <div className="max-w-4xl mx-auto text-center" data-id="element-91">
        <div className="text-white text-3xl font-serif font-black tracking-widest mb-6 flex items-center justify-center gap-3" data-id="element-92">
          <span className="text-4xl" data-id="element-93">🧘‍♀️</span> Pilates Elite™
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-94">
          EDULABS™ Pilates Risorse di eccellenza per la salute e il movimento.
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mb-8 w-full max-w-lg mx-auto mt-10" data-id="element-95" />

        <p className="text-white/50 text-xs tracking-wider" data-id="element-96">
          © EDULABS™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}